/*!
 * Created by netlogix GmbH & Co. KG.
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Appointment } from '@shared/models/appointment';

export interface AppointmentState {
  isActionPending: boolean;
  appointments: Appointment[];
  currentAppointment?: Appointment;
}

export const initialState: AppointmentState = {
  isActionPending: false,
  appointments: []
};
